import { publicEnv } from "@/config/env";
import SessionDetails from "@/features/sessions/components/session-details";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { appDetailTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

type SessionDetailSearch = {
  occasion?: string;
};

export const Route = createFileRoute("/_app/sessions/$id")({
  validateSearch: (search: Record<string, unknown>): SessionDetailSearch => {
    const occasion =
      typeof search.occasion === "string" && search.occasion.length > 0
        ? search.occasion
        : undefined;
    return occasion !== undefined ? { occasion } : {};
  },
  head: () => appDetailTitleHead("sessions"),
  component: SessionDetailPage
});

function SessionDetailPage() {
  if (publicEnv.USE_BOOKING === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <SessionDetails />
    </div>
  );
}
